<mat-card class="table-card">
  <div id="supplier" class="table-container">
    <table class="table" mat-table [dataSource]="lieferanten()">
      <ng-container matColumnDef="lieferant">
        <mat-header-cell *matHeaderCellDef class="supplier truncate" title="Lieferant">
          <div class="value-row">
            @if (openTasks()?.supplierAssignment; as supplierAssignment) {
              <mp-task-info class="task-info" [openTask]="supplierAssignment" icon="local_shipping" />
            }
            <span class="task-info-entity"> Bezugsquellen &nbsp; </span>
            @if (openTasks()?.supplierAssignment; as supplierAssignment) {
              <span class="task-info-verb">
                {{ supplierAssignment.open > 0 ? 'zuordnen' : 'zugeordnet' }}
              </span>
            }
          </div>
        </mat-header-cell>
        <mat-cell *matCellDef="let lieferant">
          <span class="value truncate font-bold" [class]="{ 'value--selected': lieferant.platformSupplier }">
            {{ lieferant.designation }}</span
          >
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="artikel">
        <mat-header-cell *matHeaderCellDef class="truncate" title="Artikel">Artikel</mat-header-cell>
        <mat-cell *matCellDef="let lieferant">
          <span class="truncate"> {{ lieferant.articleTotalCount | number }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="bezugsquelle">
        <mat-header-cell *matHeaderCellDef class="truncate" title="Zugeordneter Lieferant">
          Zugeordneter Lieferant
        </mat-header-cell>
        <mat-cell *matCellDef="let lieferant" class="value-assign-cell">
          <div class="value-assign">
            @if (!lieferant.platformSupplier) {
              <mpsm-catalog-supplier-selector
                class="value-assign__selector"
                [editMode]="canWrite()"
                [catalogType]="undefined"
                [isLoadingPlatformSuppliers]="isLoadingPlatformSuppliers()"
                [platformSuppliers]="platformSuppliers()"
                (searchTermChange)="supplierSearchTermChange.emit($event)"
                (supplierChange)="onLieferantChanges(lieferant.designation, $event)"
              />

              @if (canWrite()) {
                <button class="action-button" mat-icon-button (click)="saveBezugsquelle(true, lieferant.designation)">
                  <mat-icon>check</mat-icon>
                </button>
              }
            }

            @if (lieferant.platformSupplier; as platformSupplier) {
              <span class="saved-state truncate">
                <mat-icon class="saved-state__icon material-icons-outlined">local_shipping</mat-icon>
                <strong class="truncate">{{ platformSupplier.name }}</strong>
              </span>

              @if (canWrite()) {
                <button class="action-button" mat-icon-button (click)="deleteBezugsquelle(true, lieferant.designation)">
                  <mat-icon>close</mat-icon>
                </button>
              }
            }
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="lieferantenCols" />
      <mat-row class="table__row" *matRowDef="let row; columns: lieferantenCols" />
    </table>

    @if (lieferantenPagination(); as lieferantenPagination) {
      <mp-paginator [pagination]="lieferantenPagination" (page)="emitPageChanges(true, $event)" />
    }
  </div>
</mat-card>

<mat-card class="table-card">
  <div id="manufacturer" class="table-container">
    <table class="table" mat-table [dataSource]="hersteller()">
      <ng-container matColumnDef="hersteller">
        <mat-header-cell *matHeaderCellDef class="manufacturer truncate" title="Hersteller">
          <div class="value-row">
            @if (openTasks()?.manufacturerAssignment; as manufacturerAssignment) {
              <mp-task-info class="task-info" [openTask]="manufacturerAssignment" icon="factory" />
            }
            <span class="task-info-entity"> Hersteller &nbsp; </span>
            @if (openTasks()?.manufacturerAssignment; as manufacturerAssignment) {
              <span class="task-info-verb">
                {{ manufacturerAssignment.open > 0 ? 'zuordnen' : 'zugeordnet' }}
              </span>
            }
          </div>
        </mat-header-cell>
        <mat-cell *matCellDef="let hersteller">
          <span class="value truncate font-bold" [class]="{ 'value--selected': hersteller.platformSupplier }">
            {{ hersteller.designation }}</span
          >
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="artikel">
        <mat-header-cell *matHeaderCellDef class="truncate" title="Artikel">Artikel</mat-header-cell>
        <mat-cell *matCellDef="let hersteller">
          <span class="truncate">{{ hersteller.articleTotalCount | number }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="bezugsquelle">
        <mat-header-cell *matHeaderCellDef class="truncate" title="Zugeordneter Hersteller">
          Zugeordneter Hersteller
        </mat-header-cell>
        <mat-cell *matCellDef="let hersteller" class="value-assign-cell">
          <div class="value-assign">
            @if (!hersteller.platformSupplier) {
              <mpsm-catalog-supplier-selector
                class="value-assign__selector"
                icon="factory"
                label="Hersteller zuweisen"
                placeholder="Hersteller auswählen"
                [editMode]="canWrite()"
                [catalogType]="undefined"
                [isLoadingPlatformSuppliers]="isLoadingPlatformSuppliers()"
                [platformSuppliers]="platformSuppliers()"
                (searchTermChange)="supplierSearchTermChange.emit($event)"
                (supplierChange)="onLieferantChanges(hersteller.designation, $event)"
              />

              @if (canWrite()) {
                <button class="action-button" mat-icon-button (click)="saveBezugsquelle(false, hersteller.designation)">
                  <mat-icon>check</mat-icon>
                </button>
              }
            }

            @if (hersteller.platformSupplier; as platformSupplier) {
              <span class="saved-state truncate">
                <mat-icon class="saved-state__icon material-icons-outlined">factory</mat-icon>
                <strong class="truncate">{{ platformSupplier.name }}</strong>
              </span>

              @if (canWrite()) {
                <button
                  class="action-button"
                  mat-icon-button
                  (click)="deleteBezugsquelle(false, hersteller.designation)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              }
            }
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="herstellerCols" />
      <mat-row class="table__row" *matRowDef="let row; columns: herstellerCols" />
    </table>

    @if (herstellerPagination(); as herstellerPagination) {
      <mp-paginator [pagination]="herstellerPagination" (page)="emitPageChanges(false, $event)" />
    }
  </div>
</mat-card>

<mat-card class="table-card">
  <div id="packagingUnits" class="table-container">
    <table class="table" mat-table [dataSource]="packungseinheiten().mappings">
      <ng-container matColumnDef="einheit">
        <mat-header-cell *matHeaderCellDef class="packagingUnits truncate" title="Einheiten">
          <div class="value-row">
            @if (openTasks()?.packagingUnitsAssignment; as packagingUnitsAssignment) {
              <mp-task-info class="task-info" [openTask]="packagingUnitsAssignment" icon="straighten" />
            }
            <span class="task-info-entity"> Packungseinheiten &nbsp; </span>
            @if (openTasks()?.packagingUnitsAssignment; as packagingUnitsAssignment) {
              <span class="task-info-verb">
                {{ packagingUnitsAssignment!.open > 0 ? 'zuordnen' : 'zugeordnet' }}
              </span>
            }
          </div>
        </mat-header-cell>
        <mat-cell *matCellDef="let einheit">
          <span class="value truncate font-bold" [class]="{ 'value--selected': einheit.mappedShortName }">
            {{ einheit.shortName }}</span
          >
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="artikel">
        <mat-header-cell *matHeaderCellDef class="truncate" title="Artikel">Artikel</mat-header-cell>
        <mat-cell *matCellDef="let einheit">{{ einheit.frequency | number }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="bezugsquelle">
        <mat-header-cell *matHeaderCellDef class="truncate" title="Zugeordnete Einheit"
          >Zugeordnete Einheit</mat-header-cell
        >
        <mat-cell *matCellDef="let einheit" class="value-assign-cell">
          <mp-packaging-unit-col
            class="value-assign truncate"
            [canWritePackagingUnits]="schreibrecht4Packungseinheiten()"
            [unit]="einheit"
            [platformPackagungUnits]="packungseinheiten().units"
            (saveUnitMapping)="saveEinheit($event)"
          />
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="einheitenCols" />
      <mat-row *matRowDef="let row; columns: einheitenCols" />
    </table>

    @if (packagingUnitPagination(); as packagingUnitPagination) {
      <mp-paginator [pagination]="packagingUnitPagination" (page)="emitPackagingUnitPageChanges($event)" />
    }
  </div>
</mat-card>
